<template>
  <Page route-path="/information.html">
    <div class="body">
      <div class="head-image">
        <div class="head-image-backgroud">
          <img src="../../assets/information/banner.png" />
        </div>
        <div class="head-image-title">新闻资讯</div>
      </div>
      <div class="information-table">
        <div v-if="isNormal" class="table-record0">
          <div class="table-record0-right">
            <img :src="top.titleImage" alt="" class="article-front-image top-article" />
          </div>
          <div class="table-record0-left">
            <div class="table-record0-left-date">
              <div>{{ formatDay(top.time.day) }}</div>
              <el-divider class="datetime-divider" direction="vertical" />
              <div>{{ top.yearMonth }}</div>
            </div>
            <div class="table-record0-left-title">
              {{ top.title }}
            </div>
            <div class="table-record0-left-text">
              {{ top.summary }}
            </div>
            <div class="table-record0-left-a">
              <a :href="top.url" target="_blank" style="z-index: 1200" class="a-link"
                >查看详情 <img src="@/assets/baseIcon/jiantou.png" alt="" style="width: 16px; height: 16px"
              /></a>
            </div>
          </div>
        </div>
        <div v-if="isMobile" class="news-mobile-top">
          <div class="image-box">
            <img :src="top.titleImage" alt="" class="article-front-image top-article" />
          </div>
          <div class="content">
            <div class="table-record0-left-date">
              <div>{{ formatDay(top.time.day) }}</div>
              <el-divider class="datetime-divider" direction="vertical" />
              <div>{{ top.yearMonth }}</div>
            </div>
            <div class="content-title top-article-tile">
              {{ top.title }}
            </div>
            <div class="content-link">
              <a :href="top.url" target="_blank" class="a-link">
                查看详情
                <img src="@/assets/baseIcon/jiantou.png" alt="" style="width: 16px; height: 16px" />
              </a>
            </div>
          </div>
        </div>
        <template v-if="isNormal">
          <div class="table-box" v-for="(item, index) of currentArticlePage" :key="index">
            <div class="table-record">
              <div class="table-record-date">
                <div>{{ formatDay(item.time.day) }}</div>
                <el-divider style="margin: 12px 0px; width: 60px" />
                <div>{{ item.yearMonth }}</div>
              </div>

              <div class="table-record-content">
                <div class="content-left">
                  <div class="content-left-title">{{ item.title }}</div>
                  <div class="content-left-text">
                    {{ item.summary }}
                  </div>
                  <div class="content-left-a">
                    <a :href="item.url" target="_blank" class="a-link">
                      查看详情
                      <img src="@/assets/baseIcon/jiantou.png" alt="" style="width: 16px; height: 16px" />
                    </a>
                  </div>
                </div>
                <div class="content-right">
                  <img :src="item.titleImage" alt="" class="article-front-image" />
                </div>
              </div>
            </div>

            <!-- <el-divider /> -->
          </div>
        </template>
        <template v-if="isMobile">
          <div class="news-mobile-box" v-for="(item, index) of currentArticlePage" :key="index">
            <div class="news-mobile-box-inner">
              <div class="content">
                <div class="table-record0-left-date">
                  <div>{{ formatDay(item.time.day) }}</div>
                  <el-divider class="datetime-divider" direction="vertical" />
                  <div>{{ item.yearMonth }}</div>
                </div>

                <div class="content-title">
                  {{ item.title }}
                </div>
                <div class="content-link">
                  <a :href="item.url" target="_blank" class="a-link">
                    查看详情
                    <img src="@/assets/baseIcon/jiantou.png" alt="" style="width: 16px; height: 16px" />
                  </a>
                </div>
              </div>
              <div class="image-box">
                <img :src="item.titleImage" class="article-front-image" />
              </div>
            </div>
          </div>
        </template>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="articles.length"
          :page-size="pageSize"
          v-model:current-page="currentPage"
          @current-change="handleCurrentChange"
          style="justify-content: center; margin-top: 40px"
        />
      </div>
    </div>
  </Page>
</template>
<script>
// import {  DATA } from "./information";

import { utils } from "../../components/article-template/utils";
import { ResponsiveBase } from "../../layout/reponsive-base";

import { articleContext } from "./article-context.js";

export default {
  name: "Information",
  mixins: [ResponsiveBase],
  data() {
    console.log("-------- article context --------- ", articleContext);
    return {
      top: articleContext.top,

      articles: articleContext.articleList,

      pageSize: 5,
      currentPage: 1,
      // 当前的文章分页；
      currentArticlePage: null,
    };
  },

  inject: ["pageIndicator"],

  mounted() {
    // this.articles.sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime());
    this.currentArticlePage = this.articles.slice(0, 5);
  },

  methods: {
    open(item) {
      // let routeInfo = this.$router.resolve({
      //   path: "/informationDetail",
      //   query: { id: item.id },
      // });
      // window.open(routeInfo.href, "_blank");

      const url = encodeURI("/information-details.html?id=" + item.id);
      window.open(url, "_blank");
    },
    handleCurrentChange(val) {
      if (this.articles.length > val * 5) {
        this.currentArticlePage = this.articles.slice((val - 1) * 5, val * 5);
      } else {
        this.currentArticlePage = this.articles.slice((val - 1) * 5, this.articles.length);
      }
    },
    formatDay(day) {
      return utils.formatDigits2Number(day);
    },
  },
};
</script>
<style lang="less" scoped>
.article-front-image {
  width: 284px;
  height: 186px;
  object-fit: cover;
}

.article-front-image.top-article {
  width: 388px;
  height: 254px;
  object-fit: cover;
}

.body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px;
  padding-top: 65px;
}

.head-image {
  position: relative;
  // background: url(../../assets/information/banner.png) no-repeat center center;
  // background-size: 100% 100%;
  width: 100%;
  height: 280px;
  display: flex;
  justify-content: center;
  align-items: center;

  .head-image-backgroud{
    // width: 100%;
    // height: 280px;

    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;

    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .head-image-title {
    width: 100%;
    max-width: 1280px;
    font-size: 36px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    z-index: 1000;
  }
}

@media screen and (max-width: 850px) {
  .head-image {
    .head-image-title {
      font-size: 30px;
    }
  }
}

.information-table {
  padding: 40px 0px 80px 0px;
  margin: 0px;

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

.table-box {
  width: 100%;
  max-width: 1280px;
  min-height: 250px;

  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #e4e6ee;

  padding-right: 30px;
  padding-bottom: 20px;
}

.table-record {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  column-gap: 58px;

  padding: 20px 0px;
  //cursor: pointer;

  .table-record-date {
    width: 100%;
    min-width: 100px;
    max-width: 186px;
    height: 186px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    border-right-style: solid;
    border-right-width: 1px;
    border-right-color: #e4e6ee;
  }

  .table-record-date div {
    text-align: left;
  }

  .table-record-date div:first-child {
    font-size: 48px;
    font-family: D-DIN DIN-Bold, D-DIN DIN;
    font-weight: bold;
    color: #040420;
  }

  .table-record-date div:last-child {
    height: 19px;
    font-size: 18px;
    font-family: D-DIN-Regular, D-DIN;
    font-weight: 400;
    color: #727272;
  }

  .table-record-content {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: nowrap;

    column-gap: 30px;

    .content-right {
    }

    .content-left {
      width: 100%;
      min-width: 80px;
      height: auto;

      .content-left-title {
        font-size: 22px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #040420;
        line-height: 30px;

        /*超出部分隐藏*/
        overflow: hidden;
        /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
        text-overflow: ellipsis;

        /*将对象作为弹性伸缩盒子模型显示*/
        display: -webkit-box;
        /*设置子元素排列方式*/
        -webkit-box-orient: vertical;
        /*设置显示的行数，多出的部分会显示为...*/
        -webkit-line-clamp: 2;
      }

      .content-left-text {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #727272;
        line-height: 28px;

        max-height: 80px;
        margin-top: 28px;
        margin-bottom: 16px;

        /*超出部分隐藏*/
        overflow: hidden;
        /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
        text-overflow: ellipsis;

        /*将对象作为弹性伸缩盒子模型显示*/
        display: -webkit-box;
        /*设置子元素排列方式*/
        -webkit-box-orient: vertical;
        /*设置显示的行数，多出的部分会显示为...*/
        -webkit-line-clamp: 3;
      }

      .content-left-a {
        font-size: 16px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #2e64f3;
        line-height: 18px;
        display: flex;
        align-items: center;
        cursor: pointer;
        width: max-content;
      }
    }
  }
}

.table-record:hover {
  box-shadow: 0px 0px 10px 1px rgba(96, 129, 217, 0.15);
}

.table-record0 {
  width: 100%;
  max-width: 1280px;
  display: flex;
  //cursor: pointer;
  padding: 30px 0px 60px 0px;
  margin-bottom: 60px;

  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #2e64f3;

  @media screen and (max-width: 1280px) {
    padding-left: 30px;
    padding-right: 30px;
  }

  @media screen and (max-width: 850px) {
    padding-left: 15px;
    padding-right: 15px;
  }

  .table-record0-right {
    padding-right: 67px;
  }

  .table-record0-left {
    width: 100%;

    .table-record0-left-title {
      //   width: 825px;
      font-size: 28px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #040420;
      line-height: 42px;
      margin-top: 22px;
      margin-bottom: 12px;
    }

    .table-record0-left-text {
      //   width: 825px;
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #727272;
      line-height: 28px;
      margin-bottom: 16px;
    }

    .table-record0-left-a {
      font-size: 16px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #2e64f3;
      display: flex;
      align-items: center;
      cursor: pointer;
      width: max-content;
    }
  }
}

.table-record0-left-date {
  display: flex;
  align-items: baseline;

  .datetime-divider {
    height: 38px;
  }

  @media screen and (max-width: 850px) {
    margin-bottom: 12px;

    .datetime-divider {
      height: 24px;
    }
  }

  @media screen and (max-width: 850px) {
    margin-bottom: 6px;
  }
}

.table-record0-left-date div:first-child {
  font-size: 48px;
  font-family: D-DIN DIN-Bold, D-DIN DIN;
  font-weight: bold;
  color: #040420;
  line-height: 30px;

  @media screen and (max-width: 850px) {
    font-size: 32px;
  }

  @media screen and (max-width: 400px) {
    font-size: 24px;
  }
}

.table-record0-left-date div:last-child {
  height: 19px;
  font-size: 18px;
  font-family: D-DIN-Regular, D-DIN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;

  @media screen and (max-width: 850px) {
    font-size: 18px;
  }
}

:deep(.el-pagination .is-active) {
  background-color: #2e64f3 !important;
}

.news-mobile-top {
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #2e64f3;

  padding: 18px 0;
}

@media screen and (max-width: 850px) {
  .information-table {
    padding: 20px;
  }

  .news-mobile-top {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    column-gap: 20px;

    .content {
      .content-time-outer {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 160px;
        height: 30px;

        background: linear-gradient(-70deg, transparent 12px, #7999e3 0) top right;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .content-time-inner {
        font-size: 14pt;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        color: #2e64f3;
        text-align: center;

        width: calc(100% - 3px);
        height: calc(100% - 3px);
        background: linear-gradient(-70deg, transparent 12px, #ffffff 0) top right;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      // .content-time {
      //     font-size: 14pt;
      //     font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      //     color: #2E64F3;
      //     background:
      //         linear-gradient(-60deg, transparent 125px, #c36565 0) top right;
      //     background-size: 100% 100%;
      //     background-repeat: no-repeat;

      // }

      .content-title {
        font-size: 18px;
        line-height: 24px;
        padding: 10px 0px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      }

      .content-link {
        display: flex;
        align-items: center;
        font-size: 10pt;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        color: #2e64f3;
        cursor: pointer;
      }
    }
  }

  .news-mobile-box {
    width: 100%;

    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #e4e6ee;

    padding: 24px 24px 16px 24px;

    .news-mobile-box-inner {
      display: flex;
      width: 100%;
      column-gap: 20px;
      padding: 10px;

      flex-direction: row;
      justify-content: space-between;
    }

    .news-mobile-box-inner:hover {
      box-shadow: 0px 0px 10px 1px rgba(96, 129, 217, 0.15);
    }

    .content-time-outer {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 160px;
      height: 30px;

      background: linear-gradient(-70deg, transparent 12px, #7999e3 0) top right;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .content-time-inner {
      font-size: 14pt;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      color: #2e64f3;
      text-align: center;

      width: calc(100% - 3px);
      height: calc(100% - 3px);
      background: linear-gradient(-70deg, transparent 12px, #ffffff 0) top right;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .content-title {
      font-size: 14pt;
      line-height: 24px;
      padding: 10px 0px;
      width: 100%;
      height: 62px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    }

    .content-link {
      display: flex;
      align-items: center;
      font-size: 10pt;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      color: #2e64f3;
      cursor: pointer;
    }
  }

  .content-link {
    margin-top: 0px;
  }

  .article-front-image {
    width: 214px;
    height: 140px;
  }

  .article-front-image.top-article {
    width: 244px;
    height: 160px;
  }
}

@media screen and (max-width: 500px) {
  .article-front-image.top-article {
    width: 158px;
    height: 96px;
  }
  .article-front-image {
    width: 158px;
    height: 96px;
  }
  .news-mobile-top {
    flex-direction: column-reverse;
    row-gap: 12px;

    padding-bottom: 8px;

    .image-box {
      width: 100%;

      img {
        width: 100%;
        height: auto;
        object-fit: scale-down;
      }
    }

    .content {
      width: 100%;

      .content-title {
        font-size: 14px;
        padding: 0px;
      }
      .content-link {
        margin-top: 6px;
      }
    }
  }

  .news-mobile-box {
    padding: 10px 6px;


    .news-mobile-box-inner {

      flex-direction: column;
      row-gap: 12px;

      .content {
        .content-title {
          font-size: 14px;
          padding: 0px;
          height: auto;
        }
        .content-link {
          margin-top: 6px;
        }
      }


      .image-box{
        width: 100%;
        height: auto;

        img{
          width: 100%;
          height: auto;
          object-fit: scale-down;
        }
      }
    }
  }
}

.a-link {
  display: flex;
  align-items: center;
  color: #2e64f3;
}
</style>
